import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as _ from 'lodash';

import { LoaderEvent } from '../../../shared/message.event';
import { UtilityFunctions } from '../../../shared/utility-functions';
import { CONSTANT_VALUES } from '../../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../../constants/constants-messages';



@Component({
  selector: 'linkactivities-modal',
  templateUrl: './link-activities.component.html',
  styleUrls: ['./link-activities.component.css'],
  providers: [LoaderEvent],
  exportAs: 'linkActivitiesPopup'
})
export class LinkActivitiesPopupComponent implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  private stringConstants = CONSTANT_MESSAGES;
  @Input() cancleButton;
  @Output() notify = new EventEmitter<any>();
  @Output() notifyForEditGroup = new EventEmitter<any>();
  private facilityList;
  private selectedFacilities = [];
  private resObj = {
    activities: [],
    sendDataFlag: false
  };
  private editGroup = false;
  private editGroupObj;
  private modalTitle;
  private utilityFunctions = new UtilityFunctions();
  constructor(public router: Router, private loaderEvent: LoaderEvent) { }

  ngOnInit() {
    this.getFacility();
  }

  getFacility() {
    let that = this;
    that.facilityList = [];
    let facilityData = [];
    if (localStorage.getItem('vendor_facilityData')) {
      facilityData = JSON.parse((localStorage.getItem('vendor_facilityData')));
      facilityData.forEach(data => {
        data.data.forEach(facility => {
          if (facility.isCreatedForGroup) {
            that.facilityList.push(facility);
          }
        });
      });
    }
  }

  addFacilityToLink(e, item) {
    if (e.target.checked) {
      this.selectedFacilities.push(item._id);
    } else {
      this.selectedFacilities.splice(this.selectedFacilities.indexOf(item._id), 1);
    }
  };

  public showChildModal(editGroupObj?): void {
    this.editGroup = editGroupObj ? true : false;
    if (this.editGroup) {
      this.modalTitle = CONSTANT_MESSAGES.EDIT_LINK_ACTIVITY_TITLE;
    } else {
      this.modalTitle = CONSTANT_MESSAGES.LINK_ACTIVITY_TITLE;
    }
    if (this.editGroup) {
      this.editGroupObj = editGroupObj;
      this.updateGroup(editGroupObj);
    }
    this.childModal.config.backdrop = false;
    this.childModal.config.keyboard = false;
    this.utilityFunctions.setBackGroundBlack();
    this.childModal.show();
  }

  public hideChildModal(): void {
    try {
      this.utilityFunctions.removeBackGroundBlack();
      this.childModal.hide();
    } catch (e) {
      console.log(e);
    }
  }

  onClickOk() {
    this.resObj = {
      activities: this.selectedFacilities,
      sendDataFlag: true
    }
    if (!this.editGroup) {
      this.notify.emit(this.resObj);
    } else {
      this.updateActivtiesForGroup();
      this.notifyForEditGroup.emit(this.editGroupObj);
    }
  }

  closePopup() {
    try {
      this.notify.emit(false);
    } catch (e) {
      console.log(e);
    }
  }

  updateGroup(group) {
    this.facilityList = [];
    this.getFacility();
    let that = this;
    if (this.facilityList.length > 0) {
      this.facilityList.map(function (rec: any) {
        if (that.editGroupObj.activities.indexOf(rec._id) >= 0) {
          rec.isChecked = true;
        } else {
          rec.isChecked = false;
        }
        return rec;
      });
      this.facilityList.sort(function (a, b) {
        return !a.isChecked;
      });
      this.selectedFacilities = that.editGroupObj.activities;
    }
  }

  updateActivtiesForGroup() {
    if (this.editGroupObj) {
      this.editGroupObj['activities'] = this.selectedFacilities;
      this.editGroupObj['groupName'] = this.editGroupObj.name;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/group/create-group/link-activities/link-activities.component.ts